// Types
import { Typography } from '@mui/material';
// Components
type MemberItemProps = {
  name: string;
  memberId: string;
  navigate: (path: string) => void;
};

const MemberItem = ({ name, memberId, navigate }: MemberItemProps) => {
  const url = `/a/conversations/conversations?contactId=${memberId}`;

  const handleNavigation = (event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();

    const isNewTab = event.ctrlKey || event.metaKey || event.button === 1; // Ctrl+Click, Cmd+Click, Middle Mouse

    if (isNewTab) {
      window.open(url, '_blank', 'noopener,noreferrer');
    } else {
      navigate(url);
    }
  };

  return (
    <Typography
      variant="body2"
      color="text.secondary"
      role="link"
      tabIndex={0}
      sx={{ cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }}
      onClick={handleNavigation}
      onMouseDown={(e) => {
        if (e.button === 1) {
          handleNavigation(e);
        }
      }}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          handleNavigation(e as unknown as React.MouseEvent);
        }
      }}
    >
      {name}
    </Typography>
  );
};

export default MemberItem;
